<template>
  <div class="admin-panel">
    <div class="doc-actions">
      <button @click="parse" :disabled="running">Спарсить документацию</button>
      <button class="primary" @click="update" :disabled="running">Обновить документацию на Yandex AI</button>
      <button class="primary" @click="parseTipovyeSituacii" :disabled="running">Обновить типовые ситуации</button>
      <button class="danger" @click="stop" :disabled="!running">Остановить</button>
    </div>

    <div class="progress-log" v-if="log.length">
      <div v-for="(line, i) in log" :key="i" :class="{ 'log-error': isError(line) }">{{ line }}</div>
    </div>

    <h4>Спарсенные файлы ({{ files.length }}) <button @click="loadFiles">Обновить список</button></h4>
    <ul class="file-list">
      <li v-for="f in files" :key="f" @click="viewFile(f)" class="clickable">{{ f }}</li>
    </ul>
    <p v-if="!files.length" class="hint">Файлов нет — запустите парсинг.</p>

    <div v-if="selectedFile" class="file-content">
      <button @click="selectedFile = null">&larr; Закрыть</button>
      <h5>{{ selectedFile }}</h5>
      <pre>{{ fileContent }}</pre>
    </div>

    <div class="modal-overlay" v-if="showParseDialog" @click.self="showParseDialog = false">
      <div class="modal">
        <p>Продолжить предыдущий парсинг или начать заново?</p>
        <div class="modal-actions">
          <button @click="showParseDialog = false">Отмена</button>
          <button @click="confirmParse(false)">Начать заново</button>
          <button class="primary" @click="confirmParse(true)">Продолжить</button>
        </div>
      </div>
    </div>

    <div class="modal-overlay" v-if="showTipovyeSituaciiDialog" @click.self="showTipovyeSituaciiDialog = false">
      <div class="modal">
        <p>Что нужно обновить?</p>

        <label class="checkbox-label">
          <input type="checkbox" v-model="tipovyeSituaciiForm.updateTipovyeSituacii" />
          Обновить типовые ситуации
        </label>
        <label class="checkbox-label">
          <input type="checkbox" v-model="tipovyeSituaciiForm.updateVoprosyOtvety" />
          Обновить вопросы и ответы
        </label>

        <p v-if="tipovyeSituaciiFormError" class="error">{{ tipovyeSituaciiFormError }}</p>

        <div class="modal-actions">
          <button @click="showTipovyeSituaciiDialog = false">Отмена</button>
          <button class="primary" @click="confirmParseTipovyeSituacii">Обновить</button>
        </div>
      </div>
    </div>

    <div class="modal-overlay" v-if="showUpdateDialog" @click.self="showUpdateDialog = false">
      <div class="modal">
        <p>Обновить документацию: загрузить ранее спарсенные файлы на Yandex AI и создать новый Vector Store? Он сразу станет использоваться в чате. Прежний Vector Store нужно будет удалить вручную.</p>

        <label class="field-label">Название Vector Store</label>
        <input class="field-input" v-model="updateForm.vectorStoreName" type="text" />

        <label class="field-label">Max Chunk Size Tokens</label>
        <input class="field-input" v-model="updateForm.maxChunkSizeTokens" type="number" min="1" />

        <label class="field-label">Chunk Overlap Tokens</label>
        <input class="field-input" v-model="updateForm.chunkOverlapTokens" type="number" min="0" />

        <p v-if="updateFormError" class="error">{{ updateFormError }}</p>

        <div class="modal-actions">
          <button @click="showUpdateDialog = false">Отмена</button>
          <button class="primary" @click="confirmUpdate">Обновить</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { adminApi, postAdminStream } from '../api/admin-api';

export default {
  name: 'documentation-panel',
  data() {
    return {
      running: false,
      log: [],
      files: [],
      selectedFile: null,
      fileContent: '',
      activeStream: null,
      showParseDialog: false,
      showUpdateDialog: false,
      updateForm: { vectorStoreName: '', maxChunkSizeTokens: '', chunkOverlapTokens: '' },
      updateFormError: '',
      showTipovyeSituaciiDialog: false,
      tipovyeSituaciiForm: { updateTipovyeSituacii: false, updateVoprosyOtvety: false },
      tipovyeSituaciiFormError: '',
    };
  },
  methods: {
    isError(line) {
      return line.toLowerCase().indexOf('ошибка') > -1;
    },
    parse() {
      if (this.running) return;
      this.showParseDialog = true;
    },
    confirmParse(continueParsing) {
      this.showParseDialog = false;
      this.runStream(`/documentation/parse?continueParsing=${continueParsing}`);
    },
    defaultVectorStoreName() {
      const d = new Date();
      const pad = n => String(n).padStart(2, '0');
      return `fitness365_docs_${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}_${pad(d.getHours())}${pad(d.getMinutes())}${pad(d.getSeconds())}`;
    },
    update() {
      if (this.running) return;
      this.updateForm = { vectorStoreName: this.defaultVectorStoreName(), maxChunkSizeTokens: 800, chunkOverlapTokens: 200 };
      this.updateFormError = '';
      this.showUpdateDialog = true;
    },
    confirmUpdate() {
      const name = (this.updateForm.vectorStoreName || '').trim();
      const maxChunkSizeTokens = Number(this.updateForm.maxChunkSizeTokens);
      const chunkOverlapTokens = Number(this.updateForm.chunkOverlapTokens);

      if (!name) {
        this.updateFormError = 'Название Vector Store не может быть пустым.';
        return;
      }
      if (!Number.isInteger(maxChunkSizeTokens) || maxChunkSizeTokens <= 0) {
        this.updateFormError = 'Max Chunk Size Tokens должно быть положительным целым числом.';
        return;
      }
      if (!Number.isInteger(chunkOverlapTokens) || chunkOverlapTokens < 0) {
        this.updateFormError = 'Chunk Overlap Tokens должно быть целым числом не меньше 0.';
        return;
      }

      this.updateFormError = '';
      this.showUpdateDialog = false;
      this.runStream('/documentation/update', {
        vectorStoreName: name,
        maxChunkSizeTokens,
        chunkOverlapTokens,
      });
    },
    parseTipovyeSituacii() {
      if (this.running) return;
      this.tipovyeSituaciiForm = { updateTipovyeSituacii: false, updateVoprosyOtvety: false };
      this.tipovyeSituaciiFormError = '';
      this.showTipovyeSituaciiDialog = true;
    },
    confirmParseTipovyeSituacii() {
      const { updateTipovyeSituacii, updateVoprosyOtvety } = this.tipovyeSituaciiForm;
      if (!updateTipovyeSituacii && !updateVoprosyOtvety) {
        this.tipovyeSituaciiFormError = 'Выберите хотя бы один пункт для обновления.';
        return;
      }

      this.tipovyeSituaciiFormError = '';
      this.showTipovyeSituaciiDialog = false;
      this.runStream('/documentation/parseTipovyeSituacii', { updateTipovyeSituacii, updateVoprosyOtvety });
    },
    stop() {
      if (!this.running || !this.activeStream) return;
      if (!confirm('Вы уверены, что хотите остановить текущий процесс?')) return;
      this.activeStream.cancel();
      this.activeStream = null;
      this.running = false;
      this.log.push('Остановка...');
    },
    runStream(endpoint, body = {}) {
      this.running = true;
      this.log = [];
      this.activeStream = postAdminStream(endpoint, (evt) => {
        this.log.push(evt.message);
        if (evt.done) {
          this.running = false;
          this.activeStream = null;
          this.loadFiles();
        }
      }, (err) => {
        this.log.push('Ошибка соединения: ' + (err.message || err));
        this.running = false;
        this.activeStream = null;
      }, () => {
        this.running = false;
        this.activeStream = null;
      }, body);
    },
    async loadFiles() {
      const { data } = await adminApi.get('/documentation/files');
      this.files = data;
    },
    async viewFile(path) {
      this.selectedFile = path;
      const { data } = await adminApi.get('/documentation/files/content', { params: { path } });
      this.fileContent = data;
    },
  },
  mounted() {
    this.loadFiles();
  }
};
</script>

<style scoped>
.admin-panel {
  padding: 10px;
}

.doc-actions {
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
}

button {
  cursor: pointer;
}

button.primary {
  background: #f15540;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 8px 14px;
}

button.danger {
  background: #fff;
  color: #c0392b;
  border: 1px solid #c0392b;
  border-radius: 5px;
  padding: 8px 14px;
}

button:disabled {
  opacity: 0.5;
  cursor: default;
}

.progress-log {
  background: #111;
  color: #ddd;
  font-family: monospace;
  font-size: 12px;
  padding: 10px;
  border-radius: 6px;
  height: 250px;
  min-height: 100px;
  max-height: 80vh;
  overflow-y: auto;
  resize: vertical;
  margin-bottom: 15px;
}

.log-error {
  color: #ff6b6b;
}

.hint {
  font-size: 12px;
  color: #666;
}

.file-list {
  max-height: 250px;
  overflow-y: auto;
  list-style: none;
  padding: 0;
  margin: 0;
  font-size: 13px;
}

.file-list li {
  padding: 4px 8px;
  border-bottom: 1px solid #eee;
}

.clickable {
  cursor: pointer;
}

.clickable:hover {
  background: #f5f5f5;
}

.file-content {
  margin-top: 15px;
}

.file-content pre {
  background: #f7f7f7;
  padding: 10px;
  border-radius: 6px;
  max-height: 400px;
  overflow: auto;
  font-size: 12px;
  white-space: pre-wrap;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
}

.modal {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  max-width: 360px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

.modal p {
  margin: 0 0 15px 0;
  font-size: 14px;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 15px;
}

.field-label {
  display: block;
  font-size: 12px;
  color: #666;
  margin-bottom: 4px;
  margin-top: 10px;
}

.field-input {
  width: 100%;
  box-sizing: border-box;
  padding: 6px 8px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 13px;
}

.error {
  color: #d94a36;
  font-size: 12px;
  margin: 10px 0 0 0;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  margin-top: 10px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/documentation-panel.vue